/** A count with its noun: "1 reader", "2 readers", "2 entries". */
export const pluralize = (
  count: number,
  one: string,
  many = `${one}s`,
): string => `${count} ${count === 1 ? one : many}`;
